export default __webpack_public_path__ + "static/media/1021.1969282f.svg";